import data from './attrs/data'
import destroyed from './attrs/destroyed'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import props from './attrs/props'

export default {
    name: 'JobMessages',
    data,
    destroyed,
    methods,
    mounted,
    props
}